import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyVAT'
})
export class CurrencyVATPipe implements PipeTransform {

  transform(value: any, args : any = '$'): any {
    let amount = parseFloat(value.toString().replace(",","")).toFixed(2);
    return args+""+amount;
  }

}
